var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyDesignBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1008,
    height: 427,
    viewBox: "0 0 1008 427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "4071jy9o6a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-320 -216) translate(320 216)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEEFF2",
    d: "M0 35H1008V36H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 24,
    y: 52,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 24,
    x: 312,
    y: 52,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 40,
    x: 824,
    y: 44,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 968,
    y: 44,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 24,
    y: 100,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 24,
    x: 312,
    y: 100,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 40,
    x: 824,
    y: 92,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 968,
    y: 92,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 24,
    y: 148,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 24,
    x: 312,
    y: 148,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 40,
    x: 824,
    y: 140,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 968,
    y: 140,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 24,
    y: 196,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 24,
    x: 312,
    y: 196,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 40,
    x: 824,
    y: 188,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 968,
    y: 188,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 24,
    y: 244,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 24,
    x: 312,
    y: 244,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 40,
    x: 824,
    y: 236,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 968,
    y: 236,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 24,
    y: 292,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 24,
    x: 312,
    y: 292,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 40,
    x: 824,
    y: 284,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 968,
    y: 284,
    fill: "#F6F7F9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 24,
    fill: "#EEEFF2",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    x: 312,
    fill: "#EEEFF2",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#4071jy9o6a)",
    d: "M0 0H1008V427H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDesignBg);
export default __webpack_public_path__ + "static/media/emptyDesignBg.98045cc086c1cf028e6a4df1c6cfc361.svg";
export { ForwardRef as ReactComponent };